import { Box, Button, Flex, FlexProps, Text } from '@chakra-ui/react'
import { SampleNote as SampleNoteIcon } from '@components/icons'
import { useSampleSessions } from '@hooks'
import React from 'react'

interface SampleButtonProps {
  title: string
  type: string
}
export const SampleButton: React.FC<SampleButtonProps> = ({ title, type }) => {
  const { isLoading, createSampleSession } = useSampleSessions()

  const handleCreate = (): void => {
    createSampleSession(type)
  }

  return (
    <Flex
      flexDirection="row"
      bg="#EEF0FD"
      alignItems="center"
      justifyContent="center"
      width="auto"
      padding="0px 4px"
      border="2px solid"
      borderColor="rgb(246, 247, 254)"
      borderRadius="4px"
      _hover={{
        cursor: 'pointer',
        border: '2px solid',
        borderColor: 'primary'
      }}
    >
      <Button
        id={`pendo-sessions-sample-${type}`}
        data-click-event-name="Clicked Sample Session Link"
        data-click-text="Sample Session Link"
        variant="link"
        isLoading={isLoading}
        color="primary"
        onClick={handleCreate}
        ml={0}
        mr="xxsmall"
        textDecoration="none"
        _hover={{ textDecoration: 'none' }}
      >
        <SampleNoteIcon />
        <Text ml="4px">{title}</Text>
      </Button>
    </Flex>
  )
}
